import { createSelector } from '@ngrx/store';

import { reorderState } from '../root';

export const getReorder = (orderGUID: string, locationNo: number, pickupTime: OLO.Ordering.PickupTime) =>
    createSelector(reorderState, (reorder) => {
        if (!orderGUID || !locationNo || !pickupTime) return null;
        const foundReorder = reorder.find((obj) => obj.LocationNo === locationNo && obj.orderGUID === orderGUID && obj.PickupTime !== null && obj.PickupTime.Id === pickupTime.Id);

        return foundReorder || null;
    });
